import {useState, useEffect} from "preact/compat";

export const useLegacySatisfactionSurvey = (props) => {
    // Destructured props
    const {data} = props;

    // Controls the modal display state
    const [open, setOpen] = useState(false);

    // Opens the modal after a three-second delay
    useEffect(() => {
        if (!data.isActive) {
            return;
        }

        // Three-second timer
        const timer = setTimeout(() => {
            setOpen(true);

            clearTimeout(timer);
        }, 3000);
    }, [data.isActive]);

    return {
        open,
        setOpen
    }
}
